import { requestApi } from '../util/network'

// 发送邮箱验证码 传email 修改密码
export const send_code_to_email =
  () =>
    requestApi(
      '/member/send_code_to_email',
      'GET',
      {
      },
      'member'
    )
// 发送邮箱验证码 传email
export const getEmailCode =
  (email, member_name) =>
    requestApi(
      '/connect/send_forget_password',
      'GET',
      {
        'email': email,
        'member_name': member_name,
      }
    )
// 注册发送邮箱验证码 传email
export const getRegisterEmailCode =
  (email,username,invite_code, captcha_name, captcha_code) =>
    requestApi(
      '/connect/send_register',
      'GET',
      {
        'email': email,
        'username': username,
        'invite_code': invite_code,
        'captcha_name': captcha_name,
        'captcha_code': captcha_code
      }
    )
// 提现发送邮箱验证码
export const getWithdrawEmailCode = () =>
    requestApi(
      '/connect/send_widthdraw',
      'GET',
      {}
    )
// 获取手机验证码
export const getSmsCaptcha =
  (type, phone) =>
    requestApi(
      '/Connect/get_sms_captcha',
      'GET',
      {
        'type': type,
        'phone': phone
      }
    )
// 验证码检测
export const checkPictureCaptcha =
  (captcha) =>
    requestApi(
      '/Seccode/check',
      'POST',
      {
        'captcha': captcha
      }
    )
export const getWechatShare =
  (url) =>
    requestApi(
      '/index/getWechatShare',
      'POST',
      {
        'url': url
      }
    )